/**
 * approval (결재라인) orval 래퍼
 */
import { get } from "../endpoints/결재라인/결재라인";
import { customInstance } from "../custom-instance";
const generated = get();
// ── API 함수 ──
async function getApprovalLine(documentType, documentId) {
    return generated.approvalLineControllerGetApprovalLine(documentType, documentId);
}
async function getMyPendingSteps(documentType) {
    return customInstance({
        url: "/approval-line/my-pending",
        method: "GET",
        params: documentType ? { documentType } : undefined,
    });
}
async function approveStep(stepId, comment) {
    const body = { comment: comment ?? "" };
    return generated.approvalLineControllerPatchApprove(stepId, body);
}
async function rejectStep(stepId, comment) {
    const body = { comment };
    return generated.approvalLineControllerPatchReject(stepId, body);
}
async function resubmit(documentType, documentId) {
    return generated.approvalLineControllerPatchResubmit(documentType, documentId);
}
// ── SDK 객체 ──
export const approvalApi = {
    getApprovalLine,
    getMyPendingSteps,
    approveStep,
    rejectStep,
    resubmit,
};
